<template>
    <div>
        <div class="container mx-auto text-center max-w-lg py-10">
            <div class="px-3 py-2">
                <h2 v-text="$t('GIFT_CARD_TIME')"></h2>
                <p v-text="$t('GIFT_CARD_WE_POP', {
                    'address.first_name': $t(`${address.first_name}`)})">
                </p>
            </div>
        </div>
        <div class="background--paper divider--container py-10">
            <div class="divider-white--top"></div>
            <gift-card-message/>
            <div class="divider-white--bottom"></div>
        </div>
        <div class="container mx-auto text-center max-w-lg py-10">
            <p v-html="$t('GIFT_CARD_WE_ALSO_EMAIL', {
                'address.first_name': $t(`${address.first_name}`)})">
            </p>
            <p v-text="$t('GIFT_CARD_YOU_CAN')"></p>
            <submit-button @click="submit" v-html="$t('GIFT_CARD_FINALLY')"></submit-button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SECTION_GIFT_CARD } from '@/constants/Gifting';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import { CSPageEvents } from '@/helpers/GAHelpers';
import GiftCardMessage from '@/components/partials/account/gifting/GiftCardMessage';

export default {
    name: 'GiftCard',
    methods: {
        submit() {
            this.$store.commit('gifting/setSectionComplete', SECTION_GIFT_CARD);
            this.$router.push({ name: 'account.gifting.payment' });
            CSPageEvents('giftOneOff', {
                productType: 'gift',
                productFamily: this.selectedBoxName || this.defaultProductFamily,
                frequency: 'once',
            });
        },
    },
    computed: {
        ...mapGetters({
            selectedBoxName: 'gifting/getSelectedBoxName',
            defaultProductFamily: 'register/getDefaultProductFamily',
        }),
        address() {
            return this.$store.getters['address/getSelectedGiftingAddress'];
        },
    },
    components: {
        SubmitButton,
        GiftCardMessage,
    },
};
</script>
